// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__20TYJ","form":"styles_form__OXIhb"};